import React from 'react'
import { withRouter } from "react-router-dom";
import { ALL_PATHS } from "../../../../constants/routerConst";

import {Button,Avatar} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";


import { UserContext } from "../../../../context/UserProvider";
import googleIcon from "../../../../assets/icons/googleIcon.png"
import {googleProvider} from "../../../../config/firebase";

const useStyles = makeStyles((theme) => ({
    button: {
      margin: theme.spacing(1, 0, 0),
      background:"#fff",
      color:"black",
      fontWeight:"bold",
      fontFamily: "sans-serif"
    },
    avatar:{
      width:"25px",
      height:"25px"
    }
  }));

const GoogleAuthButton = ({label,...props}) => {
    const {inWithPopup } = React.useContext(UserContext);
    const classes = useStyles();

    const signIn=async()=>{
        await inWithPopup(googleProvider)
        props.history.push(ALL_PATHS.PATH_DASHBOARD);
        
    }
    return (
        <Button
          fullWidth
          variant="contained"
          onClick={signIn}
          className={classes.button}
          startIcon={
            
            <Avatar
              src={ googleIcon}
              className={classes.avatar}
            />
          }
        >
          {label}
        </Button>
    )
}

export default withRouter(GoogleAuthButton)
